// Editable configuration variables for Huitzil-Coatl Travels
export const BRAND = {
  name: "Huitzil-Coatl Travels",
  tagline: {
    es: "Experiencias que conectan contigo y con México.",
    en: "Experiences that connect you with yourself and with Mexico.",
  },
  logoUrl:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_c270d9f6-17d1-450f-aa85-69edf6c88c06/artifacts/fz92t3sf_Recurso%202.png",
};

export const CONTACT = {
  WHATSAPP_NUMBER: "+525545376050",
  WHATSAPP_DISPLAY: "+52 55 4537 6050",
  EMAIL: "sales@huitzilcoatl.mx",
  LOCATION: {
    es: "Ciudad de México, México",
    en: "Mexico City, Mexico",
  },
  HOURS: {
    es: "Lun a Dom · 8:00 – 20:00 (CDT)",
    en: "Mon to Sun · 8:00 – 20:00 (CDT)",
  },
};

export const SOCIAL = {
  INSTAGRAM_URL: "https://www.instagram.com/huitzil_coatlmx/",
  FACEBOOK_URL: "https://www.facebook.com/huitzilcoatltravels",
  TIKTOK_URL: "https://www.tiktok.com/@huitzil_coatlmx",
};

// Build wa.me URL with pre-populated message
export const waLink = (msg = "Hola, me interesa conocer más sobre sus experiencias.") => {
  const num = CONTACT.WHATSAPP_NUMBER.replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
};

export const CATEGORIES = [
  { key: "globos", es: "Vuelo en globo", en: "Balloon flight" },
];
